module.exports = __webpack_public_path__ + "static/media/icon-open-up.0dfa739a.svg";